import { fetchJSON } from '@eb/http';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

const MAX_CATEGORIES = 5;

// New organizer suggestions API, can search organizers by place and tag (can currently only accept tags that are prefixed EventbriteCategory)
const ORGANIZER_SUGGESTIONS_URL =
    '/api/v3/destination/organizers/suggestions/?expand.destination_profile=image&expand.destination_event=image';

export const getOrganizersForPlaceTags = (
    placeId,
    tags = [],
    excludedOrganizerIds = [],
) => {
    if (
        isEmpty(tags) ||
        !isArray(tags) ||
        tags.length > MAX_CATEGORIES ||
        !tags.every((tag) => tag.startsWith('EventbriteCategory'))
    ) {
        throw new Error(
            'getOrganizersForPlaceTags called with wrong arguments',
        );
    }

    return fetchJSON(ORGANIZER_SUGGESTIONS_URL, {
        method: 'POST',
        body: JSON.stringify({
            place_id: placeId,
            tags,
            excluded_org_ids: excludedOrganizerIds,
            exclude_sample_events: true,
        }),
    });
};

export const followOrganizer = (organizerId) =>
    fetchJSON(`/api/v3/destination/organizers/${organizerId}/follow/`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
